import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { LinearGauge } from "canvas-gauges";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./useCheckMobileScreen";

const Linear_Gauge = (props) => {
  let gaugewidth = useCheckMobileScreen() ? 50 : 100;
  let gaugeheight = useCheckMobileScreen() ? 135 : 270;
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const redcolor = "rgba(200, 50, 50, .75)";
  const yellowcolor = "rgba(244, 155, 36, .75)";
  const [state, setState] = useStateIfMounted({
    value: 0,
    unit: props.unit, //"Temp(C)"
    title: props.title,
    max: props.max,
    min: props.min,
    limitover: 0,
    limitunder: 0,
    prelimitover: 0,
    prelimitunder: 0,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        setState({
          ...state,
          value: message.value == undefined ? 0 : message.value,
          limitover:
            message.limitover == undefined || message.limitover == "N"
              ? 0
              : message.limitover,
          limitunder:
            message.limitunder == undefined || message.limitunder == "N"
              ? 0
              : message.limitunder,
          prelimitover:
            message.prelimitover == undefined || message.prelimitover == "N"
              ? 0
              : message.prelimitover,
          prelimitunder:
            message.prelimitunder == undefined || message.prelimitunder == "N"
              ? 0
              : message.prelimitunder,
        });
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
    new LinearGauge({
      renderTo: state.title + "_linear-gauge",
      value: Number(state.value),
      width: gaugewidth,
      height: gaugeheight,
      colorPlate: "#fff",
      borderShadowWidth: 0,
      borders: false,
      valueBox: false,
      needleType: "arrow",
      needleWidth: 2,
      strokeTicks: true,
      minValue: state.min,
      maxValue: state.max,
      //units: state.value + " " + state.unit,
      majorTicks: calculatemajorTicks(state.min, state.max, 10),
      animationDuration: 1500,
      animationRule: "linear",
      fontUnitsSize: 35,
      /*tickSide: "left",
      numberSide: "left",
      needleSide: "left",*/
      barStrokeWidth: 5,
      highlights: [
        {
          from: state.min,
          to: state.limitunder != 0 ? state.limitunder : state.min,
          color: redcolor,
        },
        {
          from: state.limitover != 0 ? state.limitover : state.max,
          to: state.max,
          color: redcolor,
        },
        {
          from:
            state.prelimitunder != 0
              ? state.limitunder != 0
                ? state.limitunder
                : state.min
              : state.prelimitunder,
          to: state.prelimitunder,
          color: yellowcolor,
        },
        {
          from: state.prelimitover,
          to:
            state.prelimitover != 0
              ? state.limitover != 0
                ? state.limitover
                : state.max
              : state.prelimitover,
          color: yellowcolor,
        },
      ],
    }).draw();
  }, [
    state.value,
    state.limitover,
    state.limitunder,
    state.prelimitover,
    state.prelimitunder,
    gaugewidth,
    gaugeheight,
  ]);

  useEffect(() => {});

  const calculatemajorTicks = (minValue, maxValue) => {
    const maxticksnumber = 6;
    let majorTicks = [];
    for (let i = 0; i < maxticksnumber; i++) {
      majorTicks[i] =
        Math.round(
          (((+maxValue - +minValue) / (+maxticksnumber - 1)) * i + +minValue) *
            100
        ) / 100;
    }
    return majorTicks;
  };

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  return (
    <div className="col">
      <div className="card text-center bg-light , diagramcards">
        <div className="card-header">{state.title}</div>
        <div className="card-body">
          <center>
            <canvas id={state.title + "_linear-gauge"} />
          </center>
        </div>
        <div className="card-footer">
          <h5>
            {state.value + " "}
            <strong
              style={{ fontSize: useCheckMobileScreen() ? "8px" : "12px" }}
            >
              {state.unit}
            </strong>
          </h5>
        </div>
      </div>
    </div>
  );
};
export default Linear_Gauge;
